
import {executeCallback, cloneObject} from './functions';

class Responder {

    constructor(){
        this.name = 'Responder';
        this.watchers = new Set();
        this.attachedListeners = new Map();
    }

    /**
     * set a callback to an external listener when changes are
     * triggered on this object
     */
    addResponder(name, callback, defaultValue=null, removeCallback=null){

        if(typeof name === 'object'){
            if(defaultValue == null){
                defaultValue = {};
            }
            if(typeof defaultValue !== 'object'){
                console.warn('Please provide an object with defaults for each state name');
                defaultValue = {};
            }
            name.map(x => { this.addResponder(x, callback, (defaultValue[x] || null)); });
            return;
        }

        defaultValue = (typeof defaultValue !== 'undefined')? defaultValue: null;
        
        for(let w of this.watchers){

            if(w.name == name){

                if(w.callback === callback){
                    console.warn('Listener already added for namespace ' + object.name + '.' +
                                name + ': ' + callback.toString());
                    return;
                }

                if(defaultValue !== null  && defaultValue !== w.defaultValue){
                    if(w.defaultValue !== null){
                        console.warn('Overwriting default value for responder on ' + object.name +
                                '.' + name + ' from ' + w.defaultValue + ' to ' + defaultValue);
                    }
                    w.defaultValue = defaultValue;
                }
            }

        }

        this.watchers.add({
            name: name,
            callback: callback,
            defaultValue: defaultValue,
            removeCallback: removeCallback
        });

        if(defaultValue !== null){
            this.setDefault(name, defaultValue);
        }

    }

    setDefault(name, value){
        this.trigger(name, [value]);
    }

    removeResponder(name, remove){
        if(! this.watchers){
            console.warn('trying to remove responder ('+name+') from deleted object ' + (this.name || ''));
            return;
        }
        for(let w of this.watchers){
            if(w.name == name){
                if(typeof remove !== 'boolean' &&  typeof remove !== 'undefined'){
                    if(w.callback == remove){
                        this.watchers.delete(w);
                        return;
                    }else if(w.callback instanceof Array && remove instanceof Array){
                        let keep = true;
                        if(w.callback.length == remove.length){                            
                            keep = false;
                            for(let i = 0; i < w.callback.length; i++){
                                if(w.callback[i] !== remove[i]){
                                    keep = true;
                                }
                            }
                        }
                        if(! keep){
                            this.watchers.delete(w);
                            if(w.removeCallback){
                                executeCallback(w.removeCallback);
                            }
                        }
                    }
                }else if(remove == true){
                    this.watchers.delete(w);
                    if(w.removeCallback){
                        executeCallback(w.removeCallback);
                    }
                }
            }
        }
    }



    /**
     * triggers all responders listening to name
     * todo: when listening to a parent and multiple children changed
     * it will trigger a callback for each child, while only one is 
     * needed
     */
    trigger(name='*', args=false){

        for(let w of this.watchers){
            if(name.length <= w.name.length){
                if(w.name.substring(0, name.length+1) == name+'.' || w.name == name || name == '*'){
                    let cb = w.callback;
                    if(args){
                        if(! (args instanceof Array)){
                            args = [args];
                        }
                        cb = w.callback.slice(0);
                        cb.push(...args);
                    }
                    executeCallback(cb);
                }
            }else if(name.substring(0, w.name.length+1) == w.name+'.'){
                let cb = w.callback;
                if(args){
                    cb = w.callback.slice(0);
                    cb.push(...args);
                }
                executeCallback(cb);
            }
        }
    }

    get(namespace){
        return null;
    }

    /**
     * The idea of getPrevious is to get the previous value,
     * this way a component can see what the change was and
     * for example create a transition between the two states
     */
    getPrevious(namespace){
        return null;
    }

    set(namespace, value){
        
    }


    setListeners(listeners){
        this.removeAllListeners();
        // let previous = new Map(this.attachedListeners);
        for(let listener of listeners){
            if(listener instanceof Function){
                let id = listener(this);
                // if(! id){
                //     console.warn('No id for the listener returned!');
                // }else if(previous.has(id)){
                //     previous.delete(id);
                // }
            }else{
                console.warn('Expected type for listener is Function. ' + 
                        'Could not add listener: ' + listener.toString());
            }
        }
        // for(let k of previous.keys()){
        //     this.removeListener(k);
        // }
    }

    /**
     * set a callback to this object when changes occur at an
     * external object
     */
    addListener(object, callback=null, namespace='*', defaultValue=null){
        if(!object){
            console.warn('Trying to add undefined object as a listener to:');
            console.log(this.constructor.name);
            console.log(this);
            return;
        }
        let id = object.name + '.' + namespace;
        if(this.attachedListeners.has(id)){
            console.warn('responder with same id ' + id + 
                    ' already added to controller ' + this.uid + 
                    ' and will be replaced');
            this.removeListener(id);
        }
        if(! callback){
            callback = [this, this.update];
        }
        this.attachedListeners.set(id, [object, callback, namespace]);
        object.addResponder(namespace, callback, defaultValue, [this, this.removeListener, id]);
        return id;
    }

    removeListener(id){
        let resp = this.attachedListeners.get(id);
        if(resp){
            let object = resp[0];
            let callback = resp[1];
            let namespace = resp[2] || id;
            object.removeResponder(namespace, callback);
            this.attachedListeners.delete(id);
        }
    }
    
    removeAllListeners(){
        let listeners = new Map(this.attachedListeners);
        for(let [name, callback] of listeners){
            this.removeListener(name);
        }
    }


    removeAllResponders(){
        for(let w of this.watchers){
            if(w.removeCallback){
                executeCallback(w.removeCallback);
            }
        }
        this.watchers = new Set();
    }

    remove(){
        this.removeAllListeners();
        this.removeAllResponders();
        delete this.watchers;
        delete this.attachedListeners;
    }


}

export default Responder;